import React, { useState } from 'react'
import { Form, Checkbox } from 'semantic-ui-react'

type SurveyToggleSettingsType = {
  is_active: boolean
}

type SurveySettings = {
  id: number
  name: string
  token: string
  settings: SurveyToggleSettingsType[]
}

type SurveyToggleTemplateProps = {
  isAuthenticated: boolean
  isIntegrationActive: boolean
  onChange: Function
  onIsEverySurveyIncludedChange: Function
  isEverySurveyIncluded: boolean
  surveySettings: SurveySettings[]
  everyResponseOptionLabel: string
}

export default function SurveyToggleTemplate({
  isIntegrationActive,
  isAuthenticated,
  onChange,
  onIsEverySurveyIncludedChange,
  isEverySurveyIncluded,
  surveySettings,
  everyResponseOptionLabel,
}: SurveyToggleTemplateProps) {
  const [isEverySurveyIncludedState, setIsEverySurveyIncluded] =
    useState<boolean>(isEverySurveyIncluded)

  function handleCheckboxChange(_, { value }) {
    setIsEverySurveyIncluded(value)
    onIsEverySurveyIncludedChange(value)
  }

  const isCustomFilterSurveys = !isEverySurveyIncludedState
  const disabled = !isAuthenticated || !isIntegrationActive

  return (
    <>
      <Form className="mt-4">
        <Form.Group grouped>
          <label>When should this integration run?</label>
          <Form.Field>
            <Checkbox
              radio
              disabled={disabled}
              label={everyResponseOptionLabel}
              name="is_every_survey_included"
              value={true}
              checked={isEverySurveyIncludedState === true}
              onChange={handleCheckboxChange}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              radio
              disabled={disabled}
              label="Let me choose"
              name="is_every_survey_included"
              value={false}
              checked={isEverySurveyIncludedState === false}
              onChange={handleCheckboxChange}
            />
          </Form.Field>
        </Form.Group>
      </Form>
      <SurveyToggleSettings
        isIntegrationActive={isIntegrationActive}
        isAuthenticated={isAuthenticated}
        surveySettings={surveySettings}
        onChange={onChange}
        isCustomFilterSurveys={isCustomFilterSurveys}
      />
    </>
  )
}

type SurveyToggleSettingsProps = {
  isAuthenticated: boolean
  isIntegrationActive: boolean
  surveySettings: SurveySettings[]
  onChange: Function
  isCustomFilterSurveys: boolean
}
function SurveyToggleSettings({
  isIntegrationActive,
  isAuthenticated,
  surveySettings,
  onChange,
  isCustomFilterSurveys,
}: SurveyToggleSettingsProps) {
  return (
    <div style={{ display: isCustomFilterSurveys ? 'block' : 'none', marginTop: 16 }}>
      <h4>Surveys</h4>
      <div className="grid grid-cols-1 md:grid-cols-3">
        {surveySettings.map((surveySetting, index) => (
          <SurveySentimentToggleSetting
            key={index}
            surveySetting={surveySetting}
            isIntegrationActive={isIntegrationActive}
            isAuthenticated={isAuthenticated}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  )
}

function SurveySentimentToggleSetting({
  surveySetting,
  isIntegrationActive,
  isAuthenticated,
  onChange,
}) {
  const [options, setOptions] = useState(surveySetting.settings)

  function handleOptionChange(_, { checked }) {
    setOptions((options) => ({ ...options, is_active: checked }))
    onChange({ surveyToken: surveySetting.token, name: 'is_active', value: checked })
  }

  const disabled = !isAuthenticated || !isIntegrationActive
  return (
    <div className="mb3">
      <Checkbox
        checked={options.is_active}
        disabled={disabled}
        toggle
        label={surveySetting.name}
        name={surveySetting.id}
        onChange={handleOptionChange}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/SurveyToggleSettings/index.tsx